import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import FluigService from "../../../../services/resource/fluigComprasService";
import { Loading } from "../../../../componentes/loading/loading";

function DistribuicaoPorFase({ dataInicial, dataFinal, filtrar, openModal }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tamanho, settamanho] = useState(0);
  const service = new FluigService();

  useEffect(() => {
    setLoading(true);
    service
      .resumoPorFases(dataInicial, dataFinal)
      .then((response) => {
        const labels = response.data.map((item) => item.fase);
        const values = response.data.map((item) => item.total);
        settamanho(response.data.length);

        setChartOptions({
          chart: {
            type: "bar",
            events: {
              dataPointSelection: (event, chartContext, config) => {
                const index = config.dataPointIndex;
                const label = labels[index];
                openModal(label, "fase");
              },
            },
          },
          xaxis: {
            categories: labels,
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              columnWidth: "45%",
            },
          },
          colors: [
            "#3b4ef6ff",
            "#101d8fff",
            "#3b4ef6ff",
            "#1a279cff",
            "#3b4ef6ff",
            "#101d8fff",
            "#3b4ef6ff",
            "#101d8fff",
          ],
          legend: {
            show: false,
          },
          tooltip: {
            y: {
              formatter: (val) => `Quantidade: ${val}`,
            },
          },
        });

        setChartSeries([
          {
            name: "Quantidade",
            data: values,
          },
        ]);
      })
      .finally(() => setLoading(false));
  }, [filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Distribuição Pendentes por Fase
      </h3>
      <label className="text-muted-foreground text-sm">
        Etapas atuais em que cada processo se encontra.
      </label>
      <div className="h-64">
        {!loading && tamanho > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="bar"
            height="100%"
          />
        ) : !loading ? (
          "Não existem dados disponíveis para o intervalo selecionado."
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}

export default DistribuicaoPorFase;